export default __webpack_public_path__ + "static/2-5972c17946b548ec7176aa94a621ab3e.jpg";